import { useThemeContext } from '../../context/Theme';
import { CustomNumber } from '../CustomNumber/CustomNumber';
import { Icon } from '../UI';

import { ProfitLossProps } from '../NewStrategy/types';

export const ProfitLoss = ({
  allowNegativePercentage = false,
  canUseDarkMode = true,
  center,
  className = '',
  displayType,
  isRow = false,
  handleClick = () => {},
  performancePosition = 'percentage',
  percentage,
  percentageClassName = '',
  prefixPercentage,
  prefixValue,
  suffixPercentage = '%',
  textColor,
  symbol,
  value,
  size = 'small',
  valueClassName = 'w-full min-w-16',
  usePerformance = true,
}: ProfitLossProps) => {
  const { theme } = useThemeContext();

  !textColor &&
    (textColor = percentage
      ? percentage > 0
        ? 'positive'
        : 'negative'
      : canUseDarkMode && theme === 'DARK'
      ? 'white'
      : 'black');

  return (
    <div
      className={`
        ${className}
        ${center && 'items-center'}
        flex
        text-${textColor}
        text-${size === 'large' ? 'base' : 'sm'}
        flex-${isRow || value === undefined ? 'row' : 'col'}
      `}
      onClick={() => handleClick?.()}
    >
      {typeof value === 'number' && (
        <div
          className={`
          flex
          items-center
        `}
        >
          {percentage !== null &&
            percentage !== undefined &&
            performancePosition === 'value' &&
            usePerformance && (
              <Icon
                svgName={
                  percentage === 0 ? 'still' : percentage > 0 ? 'gain' : 'loss'
                }
                canUseDarkMode={false}
                className="mr-1 h-4 w-4"
              />
            )}
          <CustomNumber
            className={`
              ${valueClassName}
              bg-transparent
            `}
            displayType={displayType}
            prefix={prefixValue}
            suffix={symbol}
            value={value}
          />
        </div>
      )}
      {percentage !== null && percentage !== undefined && (
        <div
          className={`
            flex
            items-center
          `}
        >
          {performancePosition === 'percentage' && usePerformance && (
            <Icon
              svgName={
                percentage === 0 ? 'still' : percentage > 0 ? 'gain' : 'loss'
              }
              canUseDarkMode={false}
              className="mr-1 h-4 w-4"
            />
          )}

          <CustomNumber
            allowNegative={allowNegativePercentage}
            className={`
              ${percentageClassName}
              ${performancePosition === 'value' && 'ml-1'}
              bg-transparent
              text-${size === 'large' ? 'sm' : 'xs'}
            `}
            displayType={displayType}
            decimalScale={percentage < 100 ? 2 : 0}
            prefix={prefixPercentage}
            suffix={suffixPercentage}
            value={percentage}
          />
        </div>
      )}
    </div>
  );
};
